// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__5Q9o3","colCheckbox":"styles_colCheckbox__3uPjF"};